export default "__VITE_ASSET__JbZx29po__"